import { signal } from "@preact/signals-react"

const loader = signal(false)
const param = signal(false)
const lang_json = signal(false)
const isThereError = signal(false)

const toggleLoader = (val) => {
	loader.value = val
}

export { loader, param, lang_json, isThereError, toggleLoader }
